import { White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '36px'
});

export const title = css({
  color: White.White10,
  fontSize: '32px',
  fontWeight: 700
});
